import React from 'react';

const SuccessNewIcon = () => (
  <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M31.2913 61.7497C14.4897 61.7497 0.833008 48.093 0.833008 31.2913C0.833008 14.4897 14.4897 0.833008 31.2913 0.833008C48.093 0.833008 61.7497 14.4897 61.7497 31.2913C61.7497 48.093 48.093 61.7497 31.2913 61.7497Z" fill="#5941A9" />
    <path d="M27.2663 41.4349C26.6996 41.4349 26.1613 41.2082 25.7646 40.8115L17.7461 32.7932C16.9245 31.9715 16.9245 30.6115 17.7461 29.7899C18.5678 28.9682 19.9278 28.9682 20.7495 29.7899L27.2663 36.3065L41.8296 21.7432C42.6513 20.9215 44.0113 20.9215 44.8329 21.7432C45.6546 22.5649 45.6546 23.9249 44.8329 24.7465L28.7679 40.8115C28.3713 41.2082 27.8329 41.4349 27.2663 41.4349Z" fill="white" />
  </svg>

);

export default SuccessNewIcon;
